'use client';

/**
 * Subtle film-grain overlay that sits on top of any dark surface.
 *
 * Pure CSS — no canvas/WebGL required — using a stored SVG turbulence
 * data URI. 3% opacity with a screen blend mode; invisible yet breaks
 * up the flat obsidian into something organic.
 */
export function Grain({ opacity = 0.04 }: { opacity?: number }) {
  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-0 z-[1] mix-blend-overlay"
      style={{
        opacity,
        backgroundImage:
          "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='240' height='240'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/></filter><rect width='100%25' height='100%25' filter='url(%23n)' opacity='0.75'/></svg>\")",
        backgroundSize: '240px 240px',
      }}
    />
  );
}
